import { useState, useEffect } from "react";
import { useGameContext } from "GameContext";

function VoteDistribution({
  wVotes,
  playerCount,
  selected=-1,
  live=false,
}:{
  live?: boolean,
  wVotes: Array<number>,
  playerCount: number,
  selected?: number,
}) {

  return (
    <div className="border border-black rounded p-2 relative flex flex-col gap-1">
      <h3 className="text-sm text-center">Voting Results {live ? "(LIVE)" : "" }</h3>
      { wVotes.map((wr, i) => (
        <div className="flex flex-row text-nowrap gap-2" key={i}>

          <div className=""><p>WMR {i+1}</p></div>

          <div className="relative w-full">
            <div className="absolute left-0 bg-opacity-20 bg-black h-full rounded-full"
              style={{
                width: `${ wr * 100 / playerCount}%`,
              }}
            />
          </div>

          <div className="relative w-full max-w-10">
            { (wr > 0 || selected === i+1) && (
              <p>
                {wr}
                { selected === i+1 ?  " ⭐️" : ""}
              </p>
            )}
          </div>
        </div>
      ))}
    </div>
  )
}

export default function HostVoteView () {
  const {
    wmVotes,
    selectedWmRegimes,
    wmVoteHistory,
    players,

    currentStage,

    autoVote,
    setAutoVote,

    hostSelectedWM,
    setHostSelectedWM
  } = useGameContext() as any;

  const playerCount = players.length
  const wrrs = [1,2,3,4,5]


  useEffect(() => {
    if (currentStage === "game") {
      setHostSelectedWM(-1)
    }
  }, [currentStage])

  return (
    <div className="flex flex-col p-4 gap-8 overflow-y-auto">
      <div className="border border-black p-2 rounded">
        <p>Vote settings</p>

        <div className="flex flex-row items-center gap-2">
          <input
            type="checkbox"
            checked={autoVote}
            onChange={() => {
              setAutoVote(!autoVote)
            }}
          />
          <label>Auto WM Selection</label>
        </div>
        { !autoVote && (
          <label>Auto WM Selection is turned off. Host MUST manually choose the WM for the year</label>
        )}
      </div>

      { (!autoVote && currentStage === "vote") && (
        <div className="border p-2 border-black rounded flex flex-col gap-4">
          <div className="flex flex-row gap-6">
            <h3 className="text-sm">Manual WM Selection</h3>
          </div>

          <div className="flex flex-row text-nowrap gap-2">
            { wrrs.map((wr, i) => (
              <button
                className={`border border-black p-2 px-4 bg-black ${
                  hostSelectedWM === wr ? "bg-opacity-10" : ""
                } hover:bg-opacity-10 bg-opacity-0 transition-all duration-100`}
                key={i}
                onClick={() => {
                  setHostSelectedWM(wr);
                }}
              >WMR {wr}</button>
            ))}
          </div>

          { hostSelectedWM !== -1 && (
            <label className="text-sm">Selected WM: {hostSelectedWM}</label>
          )}
        </div>
      )}

      { (currentStage === "vote") && (
        <div  className="flex flex-col">
          <h1 className="text-xl pb-2">Townhall Votes</h1>
          <VoteDistribution live={true} wVotes={wmVotes} playerCount={playerCount}/>
        </div>
      )}


      <div  className="flex flex-col">
        <h1 className="text-xl pb-2">Vote History</h1>
        <div className="gap-4 flex flex-col">
          { wmVoteHistory.map((wrvs: number[], i: number) => (
            <div key={i} className="flex flex-col">
              <h2 className="text-lg">Year: {i + 1}</h2>
              <VoteDistribution wVotes={wrvs} playerCount={playerCount} selected={selectedWmRegimes[i]}/>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}
